export const filterAddress = (geoObjects) => new Promise((resolve) => {
  const res = geoObjects.filter((value) => {
    const { Address, kind } = value.GeoObject.metaDataProperty.GeocoderMetaData;
    return Address.country_code === 'KZ'
    && kind === 'house' && Address.Components[1].name === 'Алматы';
  });
  resolve(res);
});
